import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import * as customerActions from "../../../actions/customerActions";
import * as modalActions from "../../../actions/modalActions";

import HeaderWrapper from "../../common/HeaderWrapper";
import CustomerNoteList from "./CustomerNoteList";
import CustomerNoteForm from "./CustomerNoteForm";
import Modal from "../../common/Modal";
import ConfirmModal from "../../common/ConfirmModal";

class CustomerNotesPage extends Component {
  constructor(props) {
    super(props);
    const isNotes =
      window.location.href.substr(window.location.href.lastIndexOf("/")) ===
      "/notes";

    this.state = { note: {}, adding: false, isNotes };
  }

  onClickAdd = () => {
    this.setState({ note: {}, adding: true });
    this.props.actions.showModalSuccess("noteDetailsModal");
  };

  onClickEdit = (noteId) => {
    const { customer } = this.props;

    const note = customer.notes.find((x) => x._id === noteId);
    this.setState({ note, adding: false });

    this.props.actions.showModalSuccess("noteDetailsModal");
  };

  onClickDelete = (noteId) => {
    this.props.actions.requestNoteId(noteId);
  };

  handleAdd = (note) => {
    const { customer } = this.props;
    this.props.actions.createNote(customer._id, note);
  };

  handleUpdate = (note) => {
    const { customer } = this.props;
    this.props.actions.updateNote(customer._id, note);
  };

  handleDelete = () => {
    const { customer, customerNoteToDelete } = this.props;
    this.props.actions.deleteNote(customer._id, customerNoteToDelete);
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { customer, saving, isMobile, auth } = this.props;
    const { note, search, adding, isNotes } = this.state;

    const noteForm = (
      <CustomerNoteForm
        customer={customer}
        note={note}
        adding={adding}
        saving={saving}
        onAdd={this.handleAdd}
        onSave={this.handleUpdate}
        onCancel={this.props.actions.hideModal}
        auth={auth}
      />
    );

    return (
      <div id="notes">
        <HeaderWrapper
          breadcrumbs={[{ label: "Notes" }]}
          onClickEdit={this.handleEdit}
          onClickAdd={this.onClickAdd}
          onClickAction={
            !isNotes
              ? [
                  {
                    action: () =>
                      this.props.history.push(
                        `/app/customers/${this.props.customer._id}/notes`
                      ),
                    text: "All"
                  }
                ]
              : []
          }
          onFilter={this.filter}
          isMobile={isMobile}
        />
        <div className="content-wrapper transparent">
          <CustomerNoteList
            customer={customer}
            defaultButtonText="Reassign"
            isMobile={isMobile}
            isNotes={isNotes}
            search={search}
            onClickEdit={this.onClickEdit}
            onClickDelete={this.onClickDelete}
          />
        </div>
        <Modal
          id="noteDetailsModal"
          title={adding ? "Add Note" : "Edit Note"}
          body={noteForm}
          close={this.props.actions.hideModal}
        />
        <ConfirmModal
          id="noteDeleteModal"
          title="Delete Note"
          body="Are you sure you want to delete this note?"
          close={this.props.actions.hideModal}
          confirm={this.handleDelete}
        />
      </div>
    );
  }
}

CustomerNotesPage.propTypes = {
  actions: PropTypes.object.isRequired,
  history: PropTypes.object,
  customer: PropTypes.object,
  saving: PropTypes.bool,
  customerNoteToDelete: PropTypes.string,
  isMobile: PropTypes.bool,
  auth: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    customer: state.reducers.customer,
    saving: state.reducers.savingCustomer,
    customerNoteToDelete: state.reducers.customerNoteToDelete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...customerActions, ...modalActions },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStatesToProps, mapDispatchToProps)(CustomerNotesPage)
);
